module.exports = __webpack_public_path__ + "img/BgPeople.cea8ab05.png";